import React from 'react';
const bonuses = [{
  num: '01',
  title: 'Guía Práctica de Antropometría',
  desc: 'Técnica de medición, puntos anatómicos, tablas de referencia e interpretación de resultados.',
  price: '$12.000'
}, {
  num: '02',
  title: 'Tablas de Porciones e Intercambios',
  desc: 'Equivalencias por grupo de alimentos, porciones visuales y listas de intercambio por patología.',
  price: '$9.000'
}, {
  num: '03',
  title: 'Guía de Cálculos Nutricionales',
  desc: 'Fórmulas de requerimiento energético, distribución de macronutrientes y cálculo de planes.',
  price: '$10.000'
}, {
  num: '04',
  title: 'Guía Rápida de Conceptos de Nutrición',
  desc: 'Definiciones clave, criterios diagnósticos y parámetros de referencia listos para repasar.',
  price: '$9.000'
}, {
  num: '05',
  title: 'Preguntas de Examen y Repaso',
  desc: 'Preguntas frecuentes de parciales y finales con respuestas desarrolladas por materia.',
  price: '$8.000'
}, {
  num: '06',
  title: 'Plantillas de Estudio y Seguimiento',
  desc: 'Modelos de TPs, informes y presentaciones con el formato que piden los docentes.',
  price: '$10.000'
}];
export function Bonuses() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(240,253,244) 50%, rgb(220,252,231) 100%)'
  }} data-id="element-40">
      <div className="mx-auto max-w-4xl" data-id="element-41">

        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-1" data-id="element-42">
          Más los{' '}
          <span className="text-green-700" data-id="element-43">6 Bonos Exclusivos</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-6" data-id="element-44">
          Armados por nutricionistas y docentes — incluidos siempre
        </p>

        {/* Bonus List */}
        <div className="bg-white border border-green-700/20 rounded-xl overflow-hidden shadow-sm mb-4" data-id="element-45">
          <div className="bg-green-700 px-5 py-2.5" data-id="element-46">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-47">
              🎁 LOS 6 BONOS — Incluidos siempre
            </h3>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-48">
            {bonuses.map(bonus => <div key={bonus.num} className="flex items-center gap-4 px-5 py-2" data-id="element-49">
                <span className="shrink-0 text-lg font-black text-green-700/30 w-8 text-center" data-id="element-50">
                  {bonus.num}
                </span>
                <div className="flex-1 min-w-0" data-id="element-51">
                  <span className="block text-sm font-black text-gray-900" data-id="element-52">
                    {bonus.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-53">
                    {bonus.desc}
                  </span>
                </div>
                <div className="shrink-0 flex flex-col items-end gap-0.5" data-id="element-54">
                  <span className="text-[10px] text-gray-400 line-through" data-id="element-55">
                    {bonus.price}
                  </span>
                  <span className="text-[10px] font-black text-white bg-green-700 rounded-full px-2 py-0.5" data-id="element-56">
                    GRATIS
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Total Value Footer */}
        <div className="text-center rounded-xl px-5 py-3 shadow-sm" style={{
        backgroundColor: 'rgb(240,253,244)',
        border: '1px solid rgba(34,197,94,0.3)'
      }} data-id="element-57">
          <p className="text-xs font-bold uppercase tracking-widest text-green-700 m-0 mb-1" data-id="element-58">
            Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-3" data-id="element-59">
            <span className="text-base text-gray-400 line-through" data-id="element-60">
              $58.000
            </span>
            <span className="text-lg font-black text-green-700" data-id="element-61">
              🎁 GRATIS — Incluidos siempre
            </span>
          </div>
        </div>

      </div>
    </section>;
}